import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { RequestsService } from '../../Services/requests.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from '../../Services/userservice.service';
import Swal from 'sweetalert2';
import { Location } from '@angular/common';
import { AppConfig } from '../../config';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-listforms',
  templateUrl: './listforms.component.html',
  styleUrls: ['./listforms.component.scss']
})
export class ListformsComponent implements OnInit {
  private paginator: MatPaginator;
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  @ViewChild('main')
  formulario: ElementRef;

  url = AppConfig.url_backend;
  isLoading: boolean = false;
  isLoadingiframe: boolean = true;
  displayedColumns: string[] = ['name','iframesrc', 'ver', 'editar', 'eliminar'];
  public formobjects;
  lista_forms = []

  //Variables para cargar el formulario
  nombre_form = ""
  hsform: any = {}
  form: any = {}
  formaux:any = {}
  ocr = false

  oculto = false;

  constructor(public requests: RequestsService, private router: Router, private userService: UserService, private location: Location, private _snackBar: MatSnackBar) { 
  }

  ngOnInit(): void {
    this.getData();
    this.onPropagar();
    this.userService.is_super();
  }


  getData() {
    this.requests.getForms().subscribe(
      res => {
        //console.log('listaforms',res);
        if (res) {
          this.lista_forms = res;
          console.log(this.lista_forms)
          //Se filtra la data para mostrar solo los formularios activos
          if (this.lista_forms['message'] == "No hay formularios creados") {
            this.isLoading = true;
            return;
          }
          this.lista_forms = this.lista_forms.filter((form)=> form.estado === 1);
          
          this.formobjects = new MatTableDataSource(this.lista_forms.reverse() );
          this.formobjects.paginator = this.paginator;
          this.paginator._intl.itemsPerPageLabel = 'Formularios por página';
          this.paginator._intl.lastPageLabel = 'Última página';
          this.paginator._intl.nextPageLabel = 'Página siguiente';
          this.paginator._intl.firstPageLabel = 'Primera página';
          this.paginator._intl.previousPageLabel = 'Página anterior';

          this.paginator._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
            const start = page * pageSize + 1;
            const end = (page + 1) * pageSize;
            return `${start} - ${end} de ${this.lista_forms.length}`;
          };
          
          this.isLoading = true;
        }

      },
      err => {
        //console.log(err);

        /*if(err.status == 401){
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Lo sentimos, la sesión ha expirado',
          })
          this.router.navigate(['login']);
          
          return
        }*/

        if (err.status == 401) {
          this._snackBar.open('Lo sentimos, la sesión ha expirado', '', {
              duration: 5000,
              horizontalPosition: 'left',
              verticalPosition: 'bottom'
          })
          this.router.navigate(['login']);
          return
        }

        return err;

      }

    );
  }

  filtrar(event: Event) {
    const filtro = (event.target as HTMLInputElement).value;
    this.formobjects.filter = filtro.trim().toLowerCase();
  }

  setDataSourceAttributes() {
    if (this.paginator) {
      try {
        this.formobjects.paginator = this.paginator;
      } catch (error) {
      }
    }
  }

  onPropagar(){
    this.userService.emitChange("Formularios")

  }


  async getIframeForm(nombre_form:any){
    this.isLoadingiframe = false;
    //this.oculto = false;
    document.getElementById('formioaux').removeAttribute("style")

    
    this.loadForm(nombre_form).then(()=> {  

      console.log('getIframeform');
      

      console.log("formulario ", this.formulario);
    //  setTimeout(() => {
        let height = this.formulario.nativeElement.offsetHeight;
        console.log('Height: ' + height);
        /*console.log('Height2: ' + height2);
        console.log('Height3: ' + height3);*/
        
        document.getElementById('formioaux').setAttribute("style","display:none;")
        //this.oculto = true;
        //console.log(this.formulario);
    
        console.log("aqui1 ", this.location );
        /*
        let protocolo = this.location['_platformLocation']['protocol'];
        let hostname = this.location['_platformLocation']['hostname'];
        let puerto = this.location['_platformLocation']['port'];
        */

        let protocolo = this.location['_locationStrategy']['_platformLocation']['protocol'];
        let hostname = this.location['_locationStrategy']['_platformLocation']['hostname'];
        let puerto = this.location['_locationStrategy']['_platformLocation']['port'];

        console.log("aqui ", protocolo, hostname);
    
  
        if(this.ocr){
          height = height + 138; 
        }
    
        //scrolling="no"
        
        let textoiframe = `<iframe src="${protocolo}//${hostname}/#/render/${encodeURI(nombre_form)}?h=${height}&site=x"></iframe>`
        //let textoiframe = `<iframe src="${protocolo}//${hostname}:${puerto}/#/render/${encodeURI(nombre_form)}"></iframe>`
        this.isLoadingiframe = true;
    
        Swal.fire({
          icon: 'question',
          title: `¿Desea copiar Iframe del formulario?`,
          text: textoiframe,
          showDenyButton: true,
          confirmButtonText: '<i class="fa fa-copy"></i> Copiar',
          denyButtonText: `<i class="fa fa-ban"></i> No copiar`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
    
            navigator.clipboard.writeText(textoiframe).then(function() {
              console.log('Async: Copying to clipboard was successful!');
            }, function(err) {
              console.error('Async: Could not copy text: ', err);
            });
    
            Swal.fire('¡Ruta copiada!', '', 'success')
          } else if (result.isDenied) {
            // Swal.fire('¡No se copió el IFrame!', '', 'info')
          }
        })
        
   //   }, 200);
      /*let height2 = this.formulario.nativeElement.clientHeight;
      let height3 = this.formulario.nativeElement.getBoundingClientRect().height;*/
      
     
    });


  }


  async deleteForm(element:any){
    //console.log(element);
    const name = element.nombre_form
    const formid = element.formid
    const estructura = JSON.parse(element.estructura_hs_resp)
    const guid = estructura.guid;
  
    const ocr = JSON.parse(element.estructura_hs_crear).ocr;
    //console.log(ocr);
    
    const { value: text } = await Swal.fire({
      icon: 'warning',
      title: `¿Está seguro de querer eliminar el formulario ${name}?`,
      input: 'text',
      inputPlaceholder: 'Escriba eliminar para confirmar...',
      inputAttributes: {
        'aria-label': 'Type your message here'
      },
      showCancelButton: true,
      confirmButtonColor: '#e62e1b',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar'
    })
    
    if (text === 'eliminar') {
      this.requests.hs_deleteform(guid, ocr || false);
      this.requests.deleteForm_bd(formid).subscribe(
        res =>{
          console.log(res);
          this.getData(); 
          Swal.fire(
            'Eliminación de formulario',
            `Formulario ${name} eliminado correctamente`,
            'success'
          )
        },
        err=>{
          console.error(err);

          if(err.status == 401){
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Lo sentimos, la sesión ha expirado',
            })
            this.router.navigate(['login']);
            return
          }
        }
      )
    }
  }



  async loadForm(nombre_form){

    try {
      let resp = await fetch(`${this.url}/form?nombre=${nombre_form}`)
      let body = await resp.json();
      console.log(body);
      this.form = JSON.parse(body[0].estructura_angular)
      this.formaux = JSON.parse(body[0].estructura_hs_crear)
      this.ocr = this.formaux.ocr || false
      document.getElementById('formioaux').removeAttribute("style")
      console.log('loadform');
      

    } catch (error) {
      console.log(error);
      
    }

    /*this.requests.getFormbyId(nombre_form).subscribe(
      res => {
        //console.log('res',res);
        if (res) {
          this.form = JSON.parse(res[0].estructura_angular)
          this.formaux = JSON.parse(res[0].estructura_hs_crear)
          this.ocr = this.formaux.ocr || false
        }
      },
      err => {
        console.log(err);
        return err;
      }
    );*/


  }


}
